import { isNumber } from 'lodash';

export const isInvalidTableTextCell = (text: string | number): boolean => {
	if (!text) {
		return true;
	} else if (isNumber(text)) {
		return text < 1;
	}
	return false;
};
